module.exports = __webpack_public_path__ + "static/img/universe-official-256.09683da.png";


//////////////////
// WEBPACK FOOTER
// ./src/download/assets/icons/universe-official-256.png
// module id = Qeu/
// module chunks = 1